import { render } from "./DashBoardPage.vue?vue&type=template&id=35a37cba&scoped=true"
import script from "./DashBoardPage.vue?vue&type=script&lang=js"
export * from "./DashBoardPage.vue?vue&type=script&lang=js"

import "./DashBoardPage.vue?vue&type=style&index=0&id=35a37cba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35a37cba"]])

export default __exports__